import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthService } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class SelectWhsPopupGuard {
  constructor(
    private readonly auth: AuthService,
    private readonly router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    if (
      this.auth.isUserLoggedIn() &&
      sessionStorage.getItem('accountType') !== 'INDIRECT'
    ) {
      this.router.navigate(['/my-account/account-overview']);
    } else {
      return of(true);
    }
    return of(false);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(childRoute, state);
  }
}
